<template>
  <div v-if="files && files.file" class="device-info">
    <el-table
        v-if="files.file.length !== 0"
        :data="files.file"
        stripe
        :show-header="false"
        style=""
        class="file-table">
      <el-table-column
          width="72">
        <template slot-scope="scope">

          <template v-if="isImage(scope.row.ext)">
            <el-image
                @click="openFile(scope.row)"
                v-if="scope.row.link"
                class="images-content"
                lazy
                fit="cover"
                :src="getUrlPhoto(scope.row.link.get)"
            >
              <div slot="error" class="images-content_error">
                <i class="el-icon-picture-outline"></i> Ошибка загрузки
              </div>
              <div slot="placeholder" class="images-content_loading">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </template>
          <template v-else>
            <div @click="openFile(scope.row)">
              <file-icon class="images-content"></file-icon>
            </div>
          </template>

        </template>

      </el-table-column>
      <el-table-column
          prop="full_title"
          width="180">
      </el-table-column>
      <el-table-column align="right">
        <template slot-scope="scope">
          <div class="device-btn">
            <el-button
                :loading="downloadLoading && downloadLoadingIndex === scope.row.id"
                class="device-field__btn-map"
                @click="fileDownload(scope.row)"
                icon="el-icon-download"
            />

          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import FileIcon from "@/components/icons/File"

export default {
  name: "FilesViewer",
  components: {FileIcon},
  props: {
    files: {},
  },
  data: function () {
    return {
      loading: false,
      downloadLoading: {},
      downloadLoadingIndex: null
    };
  },
  computed: {},
  methods: {
    isImage(type) {
      return type === "jpeg" || type === "jpg" || type === "png"
    },

    getUrlPhoto(file) {
      return this.$root.getUrlPhoto(file)
    },

    openFile(data) {
      this.$emit('openFile', data)
    },

    fileDownload(file) {
      this.downloadLoading = true
      this.downloadLoadingIndex = file.id

      this.$api.devices
          .fileDownload(file.id)
          .then((response) => {

            require("js-file-download")(response.data, file.full_title)
            this.downloadLoading = false
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки файла 😕",
              message: response.response.data.message,
            })
          })
    }
  }
}
</script>

<style scoped lang="scss">
.device-info {
  width: 100%;
  display: flex;

  flex-wrap: wrap;
  gap: 1rem;
  margin: 5px 0;

  &__item {
    background: #ccc;
    border-radius: 5px;
    position: relative;
    padding: 10px 5px;

    color: #fff;
  }
}


.device-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_name {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    padding: 6px;
  }

  &_action {

  }
}

.device {
  background: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;

  .file_name {
    cursor: pointer;
    color: #fff;

    &:hover {
      color: #32e6be;
    }
  }

  .device-btn {
    color: #fff !important;
    //margin-right: 16px;
  }
}

.device-field {
  &__name {
    color: #fad648;
    font-size: 16px !important;
    line-height: 26px;
    margin-top: 15px;

    display: inline-block;
  }

  &__description {
    color: #939393;
    font-size: 14px !important;
    line-height: 26px;
    margin: 10px 0 0 10px;

    display: inline-block;
  }

  &__empty {
    color: #ccc;
    font-size: 12px;
    line-height: 13px;
  }

  &__btn-map {
    border: none !important;
  }
}

/deep/ .file-table {
  width: 100%;

  &:before {
    content: "";
    position: absolute;
    background: none;
    z-index: 1;
  }

  /deep/ .el-table__row {
    td {
      padding: 9px 0 !important;
      border-bottom: 0 !important;
    }

    td:last-child {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }

    td:first-child {
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }
  }

  .el-table__row--striped {
    border-radius: 4px;

    td {
      background: #EFEFF4 !important;
    }
  }


  th.is-leaf, td {
    border: 0;
  }

  .cell {
    padding: 0 !important;
  }
}


.images-content {
  width: 40px;
  height: 40px;
  display: flex;
  padding: 0;
  margin: 0 16px;
  cursor: pointer;
  border-radius: 4px;

  transition: all .2s ease;

  &:hover {
    opacity: .8;
  }

  &_name {

  }

  &_loading {
    width: 40px;
    height: 40px;

    text-align: center;
    background: #e3e3e3;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  &_error {
    color: red;
    text-align: center;
    width: 100%;
    background: #e3e3e3;
  }
}

</style>
